import { render } from "./GoodTableSubCategories.vue?vue&type=template&id=a2710166"
import script from "./GoodTableSubCategories.vue?vue&type=script&lang=js"
export * from "./GoodTableSubCategories.vue?vue&type=script&lang=js"

import exportComponent from "/Users/fahrezibayuprabowo/Documents/project/accessories-cellular-frontend-dev-muped/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__